import { listenLoginEvent } from '@eastcoal/auth/utils/event'

import { loadScript } from '../utils'

import { RumConfig } from './interface'

const SDK_SRC = 'https://ch1nb-sdk.rum.aliyuncs.com/v2/browser-sdk.js'

export const setupRum = async ({ filters, ...restConfig }: RumConfig) => {
  window.__rum = {
    endpoint: 'https://ch1nb-default-cn.rum.aliyuncs.com',
    // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
    env: 'prod',
    // 链路追踪 https://help.aliyun.com/zh/arms/user-experience-monitoring/use-cases/trace-associated-with-rum-monitoring?spm=a2c4g.11186623.0.0.37e6128cOI27uI
    tracing: {
      enable: true, // 开启链路追踪，默认关闭
      sample: 100, // 采样率60%，默认100%
      tracestate: true, // 开启tracestate的透传，默认开启
      baggage: false, // 关闭baggage的透传，默认关闭
      propagatorTypes: ['tracecontext', 'b3'],
      allowedUrls: [url => url.includes('eastcoal.cn')]
    },
    collectors: {
      // 页面性能指标监听开关，默认开启
      perf: true,
      // WebVitals指标监听开关，默认开启
      webVitals: true,
      // Ajax监听开关，默认开启
      api: true,
      // 静态资源开关，默认开启
      staticResource: true,
      // JS错误监听开关，默认开启
      jsError: true,
      // 控制台错误监听开关，默认开启
      consoleError: true,
      // 用户行为监听开关，默认开启
      action: true
    },
    filters: {
      // 过滤掉 donut 的上报请求
      resource: [
        'https://dldir1.qq.com',
        'https://dev.weixin.qq.com',
        'https://servicewechat.com',
        url => url.includes('ap-shanghai.myqcloud.com')
      ],
      exception: [
        msg => {
          return msg.includes('WechatWebDev')
        }
      ]
    },
    async evaluateApi(options, response, error) {
      return {
        name: options.url, // 接口名称
        success: response.ok ? 1 : 0,
        // 以下可选
        snapshots: JSON.stringify({
          request: {
            method: options.method, // 请求方法
            headers: options.headers // 请求头
          }, // 请求入参
          response: {
            status: response.status, // 响应状态码
            headers: response.headers, // 响应头
            data: await response.text() // 响应数据
          }
        })
      }
    },
    ...restConfig
  }
  await loadScript(SDK_SRC)
  listenLoginEvent(store => {
    if (window.RumSDK) {
      window.RumSDK.default.setConfig({
        ...window.RumSDK.default.getConfig(),
        user: {
          name: store.user.name,
          tags: store.member.name
        }
      })
    }
  })
}
